export function sendEmail(emailObj) {
    const emailUrl = process.env.REACT_APP_EMAIL_API;
    const promise = new Promise((resolve, reject) => {
      // fetch mar 2 data
      fetch(emailUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(emailObj)
      })
      .then(
          res => {
            return res.json();
          },
          () => reject('An unexpected problem occured')
      )
      .then(data => {
          if (!data) {
            reject('No results...');
          } else {
            if (data.Success) {
              resolve(data.Success);
            } else {
              reject('No results');
            }
          }
        });
    });
    return promise;
}